<page-toolbar [pageActions]="pageActions" title="{{'analytics.title' | translate}}: {{organisationName}}"></page-toolbar>

<page-content class="analytics">

  <ng-container *ngIf="!error">
    <mat-card appearance="outlined">
      <mat-card-title>{{ 'analytics.settings' | translate }}</mat-card-title>

      <div class="fields">
        <mat-form-field *ngIf="types?.length > 0">
          <mat-label>{{ 'analytics.channel.label' | translate }}</mat-label>
          <mat-select (selectionChange)="getAnalyticsWithFilteredTypes()" [(ngModel)]="typeFilter" [disabled]="!isLoaded">
            <ng-container *ngFor="let item of types">
              <mat-option [value]="item">
                {{ 'analytics.channel.' + item | translate }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <input (dateChange)="getAnalytics(true)" [(ngModel)]="fromDate" [disabled]="!isLoaded" [matDatepicker]="pickerFrom" [max]="toDate"
                 matInput placeholder="{{'analytics.fromDate' | translate}}">
          <mat-datepicker-toggle [for]="pickerFrom" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #pickerFrom (viewChanged)="getAnalytics(true)"></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
          <input (dateChange)="getAnalytics(true)" [(ngModel)]="toDate" [disabled]="!isLoaded" [matDatepicker]="pickerTo" [max]="maxDate"
                 [min]="fromDate" matInput placeholder="{{'analytics.toDate' | translate}}">
          <mat-datepicker-toggle [for]="pickerTo" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #pickerTo></mat-datepicker>
        </mat-form-field>
      </div>

      <div>
        <button (click)="setDateByButton(button)" *ngFor="let button of monthButtons" [disabled]="!isLoaded"
                class="ibexfusion-raised-button date-button" mat-button>{{ button.title }}
        </button>
      </div>

      <div *ngIf="playOuts?.length > 1" class="playouts">
        <div class="playout-selection-title">
          <h2>{{ 'analytics.playOuts' | translate }}</h2>
          <button (click)="selectAllFilters()" [disabled]="!isLoaded" class="ibexfusion-raised-button"
                  mat-button>{{ 'analytics.selectAll' | translate }}
          </button>
          <button (click)="unselectAllFilters()" [disabled]="!isLoaded" class="ibexfusion-raised-button"
                  mat-button>{{ 'analytics.unselectAll' | translate }}
          </button>
          <button (click)="saveFilterConfiguration()" [disabled]="!isLoaded" class="ibexfusion-raised-button"
                  mat-button>{{ 'analytics.saveSelection' | translate }}
          </button>
          <button (click)="applySavedFilter(filter)" *ngFor="let filter of savedFilters" [disabled]="!isLoaded"
                  class="ibexfusion-raised-button" mat-button><span class="text">{{ filter.title }}</span>
            <mat-icon (click)="deleteFilter(filter._id)">delete</mat-icon>
          </button>
        </div>
        <mat-checkbox (click)="togglePlayout($event, playOut)" *ngFor="let playOut of playOuts" [checked]="isPlayoutActive(playOut)"
                      [disabled]="!isLoaded" [matTooltip]="playOut.name" class="playout-button">
          <span class="name">{{ playOut.name | translate }}</span>
          <span *ngIf="!!isLoaded" class="count">({{ getCountByPlayout(playOut) }})</span>
        </mat-checkbox>
      </div>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="!noData">
    <mat-expansion-panel *ngIf="timelineChartData" [expanded]="true">
      <mat-expansion-panel-header>{{ 'analytics.view.topCount' | translate }}: {{ totalCount }}</mat-expansion-panel-header>
      <timeline-chart [series]="timelineChartData" [id]="'analytics-timeline'"></timeline-chart>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="sessionTimelineChartData" [expanded]="true">
      <mat-expansion-panel-header>{{ 'analytics.view.topCountSessions' | translate }}: {{ totalSessionCount }}</mat-expansion-panel-header>
      <timeline-chart [series]="sessionTimelineChartData" [id]="'analytics-session-timeline'"></timeline-chart>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="defBarChartData && defBarChartData.length" [expanded]="true">
      <mat-expansion-panel-header>
        <div class="exp-header">
          <div class="left">
            <span class="text">{{ 'analytics.view.top' | translate }}</span>
            <mat-form-field (click)="$event.stopPropagation()" *ngIf="types?.length > 0">
              <mat-label>{{ 'analytics.pathDepth' | translate }}</mat-label>
              <mat-select (selectionChange)="changePathDepth($event)">
                <mat-option [value]="0">Alle</mat-option>
                <mat-option [value]="1">1</mat-option>
                <mat-option [value]="2">2</mat-option>
                <mat-option [value]="3">3</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="right">
            <button (click)="downloadAnalytics($event)" class="ibexfusion-raised-button" mat-button>
              <mat-icon>get_app</mat-icon>
              CSV
            </button>
          </div>
        </div>
      </mat-expansion-panel-header>
      <div style="min-height: 350px">
        <ng-container *ngIf="barChartData && barChartData.series && barChartData.categories">
          <bar-chart [categories]="barChartData.categories" [series]="barChartData.series"></bar-chart>
        </ng-container>
      </div>
      <div *ngIf="barChartDataCount" class="table-footer">
        <div class="left">
          <div class="item-count">Total {{ barChartDataCount }} {{ 'general.dataTableItems' | translate }}</div>
        </div>

        <div class="right">
          <span class="select-label">{{ 'general.itemsPerPage' | translate }}</span>
          <mat-select (selectionChange)="perPageChange($event)" [(value)]="perPage">
            <mat-option [value]="5">5</mat-option>
            <mat-option [value]="10">10</mat-option>
            <mat-option [value]="25">25</mat-option>
          </mat-select>

          <button (click)="onNavigate('first')" [disabled]="pageIndex === 0" mat-icon-button>
            <mat-icon>first_page</mat-icon>
          </button>
          <button (click)="onNavigate('previous')" [disabled]="pageIndex === 0" mat-icon-button>
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button (click)="onNavigate('next')" [disabled]="pageIndex === maxPage" mat-icon-button>
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button (click)="onNavigate('last')" [disabled]="pageIndex === maxPage" mat-icon-button>
            <mat-icon>last_page</mat-icon>
          </button>
        </div>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="pieChartData" [expanded]="true">
      <mat-expansion-panel-header>
        <div class="exp-header">
          <div class="left">
            <span class="text">{{ 'analytics.view.screenCount' | translate }}</span>
          </div>
          <div class="right">
            <button (click)="downloadAnalyticsByPlayout($event)" class="ibexfusion-raised-button" mat-button>
              <mat-icon>get_app</mat-icon>
              CSV
            </button>
          </div>
        </div>
      </mat-expansion-panel-header>
      <div class="table">
        <div class="list-element">
          <div class="name">Playout</div>
          <div *ngFor="let type of availablePlayoutTypes" class="count">{{ type }}</div>
          <div class="count">Total</div>
        </div>
        <div class="list-element" *ngFor="let element of pieChartData">
          <div class="name">{{ element.name }}</div>
          <div *ngFor="let type of availablePlayoutTypes" class="count">{{ element[type] }}</div>
          <div class="count">{{ element.count }}</div>
        </div>
      </div>
    </mat-expansion-panel>
  </ng-container>

  <mat-card appearance="outlined" *ngIf="!isLoaded">
    <h4>{{ 'analytics.loading' | translate }}</h4>
    <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="noData || error">
    <h4>{{ 'analytics.noData' | translate }}</h4>
    <p [innerText]="noData ? noData : error"></p>
  </mat-card>
</page-content>
